import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import {
  SlackIntegrationError,
  SlackIntegrationErrorCode,
} from '@webapp/platform/integrations/business-logic/errors/SlackIntegrationError'
import messages from './messages'
import { useLinkSlackUserModel } from '../../models/useLinkSlackUserModel'

export const useLinkSlackUserPresenter = () => {
  const { linkUser: linkUserMutation, isLinking } = useLinkSlackUserModel()
  const intl = useProcurifyIntl()

  const linkUser = async (
    procurifyUserId: number,
    slackUserId: string
  ): Promise<void> => {
    try {
      await linkUserMutation({ procurifyUserId, slackUserId })

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch (error) {
      const code =
        error instanceof SlackIntegrationError
          ? error.code
          : SlackIntegrationErrorCode.DEFAULT
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          code === SlackIntegrationErrorCode.TOKEN_REVOKED
            ? intl.formatMessage(messages.reconnectErrorMessage)
            : intl.formatMessage(messages.defaultErrorMessage),
      })
      throw error
    }
  }

  return {
    linkUser,
    isLinking,
  }
}
